import { hasValidContent, hasValidTimeWindow, isVisible } from 'client/store/systemMessageSlice/systemMessageSlice';
import styles from './SystemMessage.module.scss';
import Markdown from '../MarkDown/Markdown';

const SystemMessage = ({ message }) => {
    if (!message || !hasValidContent(message) || !isVisible(message) || !hasValidTimeWindow(message)) {
        return null;
    }

    const getVariant = (messageType) => {
        switch (messageType) {
            case 'maintenance':
                return 'warning';
            case 'incident':
                return 'error';
            case 'resolved':
                return 'success';
            case 'info':
            default:
                return 'info';
        }
    };

    const variant = getVariant(message.messageType);

    return (
        <Markdown
            className={styles[variant]}
            data-testid={`systemMessage.${message.location || 'global'}`}
        >
            {message.message}
        </Markdown>
    );
};

export default SystemMessage;
